module.exports = __webpack_public_path__ + "static/rollover_carro-fdd85dd9f1ad91bd557784b96be9f194.svg";